import { init, track } from '@plausible-analytics/tracker';

const PLAUSIBLE_DOMAIN = import.meta.env.VITE_PLAUSIBLE_DOMAIN || 'semn.ai';
const TRACK_LOCALHOST = import.meta.env.VITE_PLAUSIBLE_TRACK_LOCALHOST === 'true';

let initialized = false;
const trackedOnce = new Set<string>();

function shouldTrack(): boolean {
  if (typeof window === 'undefined') return false;
  if (TRACK_LOCALHOST) return true;

  const hostname = window.location.hostname;
  return hostname !== 'localhost' && hostname !== '127.0.0.1';
}

export function initializeAnalytics(): void {
  if (initialized || !shouldTrack()) return;

  init({
    domain: PLAUSIBLE_DOMAIN,
  });

  initialized = true;
}

export function trackEvent(eventName: string): void {
  if (!eventName) return;

  initializeAnalytics();
  if (!initialized) return;

  try {
    track(eventName, {});
  } catch (error) {
    if (import.meta.env.DEV) {
      console.debug('Failed to track analytics event:', eventName, error);
    }
  }
}

export function trackEventOnce(eventName: string): void {
  if (!eventName || trackedOnce.has(eventName)) return;
  trackedOnce.add(eventName);
  trackEvent(eventName);
}

export function routeToEvent(pathname: string): string {
  if (pathname === '/') return 'page_terminal';
  if (pathname === '/auth/callback') return 'page_auth_callback';
  if (pathname === '/billing/success') return 'page_billing_success';
  if (pathname === '/billing/cancel') return 'page_billing_cancel';
  return 'page_other';
}
